import React from 'react';
import { pick } from 'lodash';
import { Field } from 'redux-form';
import normalizeCurrencyFor from '../lib/currency-normalizer';
import serializeCurrencyFor from '../lib/currency-serializer';

const ALLOWED_PROPS = [
  'name',
  'label',
  'value',
  'maxLength',
  'noGroup',
  'component',
  'className',
  'onClick',
  'validate',
  'normalize',
];

const onFieldFocus = (ev) => {
  ev.target.select();
};

export default (props) => {
  const fieldProps = pick(props, ALLOWED_PROPS);
  fieldProps.onChange = (ev) => {
    if (props.onChange) {
      const serializer = serializeCurrencyFor(props.currency);
      return props.onChange(serializer(ev.target.value));
    }
  };

  return (
    <Field
      {...fieldProps}
      type="text"
      format={normalizeCurrencyFor(props.currency)}
      parse={serializeCurrencyFor(props.currency)}
      onFocus={onFieldFocus}
      className={`${fieldProps.className} money-field`}
    />
  );
};



// WEBPACK FOOTER //
// ./src/desktop/components/money-field.js